import axios from '../axios'

export async function createDefaultKassaDenom(kassaid: number, auth: Auth): Promise<KassaDenom> {
    const result: KassaDenom = {
        kassaid,
        ordercoins:    true,
        ordernotes:    true,
        announcecoins: true,
        announcenotes: true,
        coins: [],
        notes: []
    }

    const { data: coup } = await axios.post('param/coupure', { token: auth.data?.token })
    if (coup.errorcode !== 0 || !Array.isArray(coup.object.coupure)) {
        throw new Error("Couldn't fetch param coupures")
    }

    const coupures: ParamCoupure[] = coup.object.coupure
    result.coins = coupures
        .filter((c) => c.cn === 'C')
        .map((c, i) => ({ kassaid, id: i, coupure: c.value, minqty: 0, maxqty: 0, perqty: c.unit }))
    result.notes = coupures
        .filter((c) => c.cn === 'N')
        .map((c, i) => ({ kassaid, id: i, coupure: c.value, minqty: 0, maxqty: 0, perqty: c.unit }))

    return result
}
